let invoiceClip = [
    {
        path:"/invoiceClipDetail",
        name:"invoiceClipDetail",
        component: () => import("@/views/invoiceClip/invoiceClipDetail.vue"),
        meta:{
            title:"发票详情"
        },
    },
]

export default invoiceClip;